import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { TextField, Button, MenuItem } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Request_Get_Agencies_Fuzzy_Search } from "../../api/Request_Get_Agencies_Fuzzy_Search";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../../api/Get_limited_Choose_Fields_From_MongoDB";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SearchBar({ setAgencies }) {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Staff---------------------------------------------
  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB(
      "Staff",
      "Users",
      100,
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //Filter the staff for IP's
  let IPStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("ip".toLowerCase())
  );
  //Table Search
  const [searchName, setSearchName] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchStaffID, setSearchStaffID] = useState("");
  const handleSearchName = (event) => {
    setSearchName(event.target.value);
  };
  const handleSearchCountry = (event) => {
    setSearchCountry(event.target.value);
  };
  const handleSearchStaffID = (event) => {
    setSearchStaffID(event.target.value);
  };
  function handleSubmit(e) {
    e.preventDefault();
    Request_Get_Agencies_Fuzzy_Search(
      "IP",
      "Agencies",
      searchName,
      searchCountry,
      searchStaffID,
      100,
      setAgencies,
      logout
    );
  }

  function handleGetAll(e) {
    e.preventDefault();
    Request_Get_Agencies_Fuzzy_Search(
      "IP",
      "Agencies",
      "",
      "",
      "",
      100000,
      setAgencies,
      logout
    );
  }

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "25%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Search Bar
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Change to row to align items in a line
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically
          gap: "5px",
          color: "black",
          padding: "5px",
        }}
      >
        <TextField
          id="search_name"
          label="Name"
          variant="outlined"
          value={searchName}
          onChange={handleSearchName}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <TextField
          id="search_country"
          label="Country"
          variant="outlined"
          value={searchCountry}
          onChange={handleSearchCountry}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />

        <TextField
          required
          select
          id="search_StaffID"
          label="Staff"
          value={searchStaffID}
          onChange={handleSearchStaffID}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        >
          <MenuItem value="">---None---</MenuItem>
          {IPStaff.map((prop) => (
            <MenuItem value={prop._id}>{prop.Username}</MenuItem>
          ))}
        </TextField>
        <TextField
          id="search_StaffID"
          label="ID"
          variant="outlined"
          value={searchStaffID}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
          disabled
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none" }}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Search
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none" }}
          onClick={(e) => {
            handleGetAll(e);
          }}
        >
          Get All
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBar;
